import React from "react";
import ContentLoader from "react-content-loader";
import {
  FiArrowLeft,
  FiPackage,
  FiDollarSign,
  FiShoppingCart,
  FiPercent,
  FiFileText,
  FiTrendingUp,
  FiLayers,
} from "react-icons/fi";
import { GoLaw } from "react-icons/go";

const SupplierDetailLoadingSkeleton = ({ isDark = true, onVoltar }) => {
  const backgroundColor = isDark ? "#1a1a1a" : "#f0f0f0";
  const foregroundColor = isDark ? "#2a2a2a" : "#e5e7eb";

  return (
    <div className="content-wrapper">
      {/* Header com botão voltar */}
      <div className="product-header">
        <button className="back-button" onClick={onVoltar}>
          <FiArrowLeft />
          <span>Voltar</span>
        </button>
        <div className="product-info-bar">
          <div className="product-icon">
            <FiPackage />
          </div>
          <div className="product-content">
            <h2>
              <ContentLoader
                speed={2}
                width={300}
                height={24}
                backgroundColor={backgroundColor}
                foregroundColor={foregroundColor}
              >
                <rect x="0" y="0" rx="4" ry="4" width="300" height="24" />
              </ContentLoader>
            </h2>
            <div className="product-badges">
              {[...Array(4)].map((_, i) => (
                <span key={`badge-${i}`} className="badge">
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="100" height="14" />
                  </ContentLoader>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tabs de Navegação */}
      <div className="tabs-container">
        <button className="tab active">
          <FiLayers />
          <span>Geral</span>
        </button>
        <button className="tab">
          <FiPackage />
          <span>Produtos</span>
        </button>
        <button className="tab">
          <FiFileText />
          <span>Histórico</span>
        </button>
        <button className="tab">
          <GoLaw />
          <span>Reforma Tributária</span>
        </button>
      </div>

      {/* Linha 1: Métricas de Compras */}
      <div className="kpi-grid kpi-grid-4">
        {[
          { icon: FiDollarSign, label: "Total de Compras", className: "primary" },
          { icon: FiShoppingCart, label: "Total de Pedidos", className: "success" },
          { icon: FiDollarSign, label: "Ticket Médio", className: "" },
          { icon: FiPackage, label: "Produtos Únicos", className: "info" },
        ].map((item, i) => (
          <div key={`kpi-${i}`} className={`kpi-card ${item.className}`}>
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={100}
                    height={20}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="100" height="20" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 2: Créditos Tributários */}
      <div className="kpi-grid kpi-grid-4">
        {["ICMS Crédito", "PIS/COFINS", "IPI Crédito", "ICMS-ST"].map((label, i) => (
          <div key={`credit-${i}`} className="kpi-card">
            <div className="card-content">
              <div className="thumb">
                <FiFileText />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>{label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Linha 3: Resumo de Créditos */}
      <div className="kpi-grid kpi-grid-3">
        {[
          { icon: FiPercent, label: "Crédito por Pedido" },
          { icon: FiDollarSign, label: "Total de Créditos" },
          { icon: FiPercent, label: "% de Crédito" },
        ].map((item, i) => (
          <div key={`summary-${i}`} className="kpi-card">
            <div className="card-content">
              <div className="thumb">
                <item.icon />
              </div>
              <div className="text">
                <p>
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={18}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="4" ry="4" width="80" height="18" />
                  </ContentLoader>
                </p>
                <p>{item.label}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Gráficos */}
      <div className="section-row">
        {/* Evolução de Compras */}
        <div className="stats-card chart-card">
          <div className="card-header">
            <div className="header-title">
              <FiTrendingUp />
              <h4>Evolução de Compras</h4>
            </div>
          </div>
          <div className="chart-body">
            <ContentLoader
              speed={2}
              width={600}
              height={250}
              backgroundColor={backgroundColor}
              foregroundColor={foregroundColor}
            >
              {[...Array(12)].map((_, i) => {
                const x = 20 + i * 48;
                const heights = [180, 220, 160, 240, 200, 190, 210, 170, 230, 195, 215, 185];
                return (
                  <rect key={i} x={x} y={250 - heights[i]} rx="4" ry="4" width="35" height={heights[i]} />
                );
              })}
            </ContentLoader>
          </div>
        </div>

        {/* Distribuição de Créditos */}
        <div className="stats-card chart-card">
          <div className="card-header">
            <div className="header-title">
              <FiFileText />
              <h4>Distribuição de Créditos</h4>
            </div>
          </div>
          <div className="chart-body">
            <div style={{ 
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center", 
              padding: "24px", 
              minHeight: "250px" 
            }}>
              <div style={{
                width: "40px",
                height: "40px",
                border: "4px solid rgba(139, 92, 246, 0.2)",
                borderTop: "4px solid #8b5cf6",
                borderRadius: "50%",
                animation: "spin 1s linear infinite"
              }}></div>
              <style>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
            </div>
          </div>
        </div>
      </div>

      {/* Produtos e Histórico */}
      <div className="section-row">
        {/* Principais Produtos */}
        <div className="stats-card list-card">
          <div className="card-header">
            <div className="header-title">
              <FiPackage />
              <h4>Principais Produtos</h4>
            </div>
          </div>
          <div className="list-body">
            {[...Array(5)].map((_, i) => (
              <div key={`product-${i}`} className="list-item">
                <div className="item-info">
                  <span className="item-name">
                    <ContentLoader
                      speed={2}
                      width={200}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="200" height="14" />
                    </ContentLoader>
                  </span>
                  <span className="item-meta">
                    <ContentLoader
                      speed={2}
                      width={120}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="120" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="item-value">
                  <ContentLoader
                    speed={2}
                    width={90}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="90" height="14" />
                  </ContentLoader>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Histórico Recente */}
        <div className="stats-card list-card">
          <div className="card-header">
            <div className="header-title">
              <FiFileText />
              <h4>Histórico Recente</h4>
            </div>
          </div>
          <div className="list-body">
            {[...Array(5)].map((_, i) => (
              <div key={`history-${i}`} className="list-item">
                <div className="item-info">
                  <span className="item-name">
                    <ContentLoader
                      speed={2}
                      width={150}
                      height={14}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="150" height="14" />
                    </ContentLoader>
                  </span>
                  <span className="item-meta">
                    <ContentLoader
                      speed={2}
                      width={80}
                      height={11}
                      backgroundColor={backgroundColor}
                      foregroundColor={foregroundColor}
                    >
                      <rect x="0" y="0" rx="3" ry="3" width="80" height="11" />
                    </ContentLoader>
                  </span>
                </div>
                <div className="item-value">
                  <ContentLoader
                    speed={2}
                    width={80}
                    height={14}
                    backgroundColor={backgroundColor}
                    foregroundColor={foregroundColor}
                  >
                    <rect x="0" y="0" rx="3" ry="3" width="80" height="14" />
                  </ContentLoader>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierDetailLoadingSkeleton;
